const productMain = document.querySelector('.product-section__main');
const titleMain = productMain.querySelector('.product-title-wrapper');
const titleFeaturedBrand = document.querySelector(
  '.featured-brand-section__title-wrapper'
);
const mediaContainer = productMain.querySelector('.product__media-wrapper');

function handleScroll() {
  // function to handle title with Featured Brand
  if (productMain.hasAttribute('data-featured-brand')) {
    if (
      window.scrollY + window.innerHeight >=
      titleFeaturedBrand.offsetTop + 42
    ) {
      titleMain.style.opacity = '0';
      titleFeaturedBrand.style.opacity = '1';
    } else {
      titleMain.style.opacity = '1';
      titleFeaturedBrand.style.opacity = '0';
    }
  } else {
    // Function to handle title without featured brand
    if (
      window.scrollY + window.innerHeight >
      mediaContainer.clientHeight + mediaContainer.offsetTop
    ) {
      titleMain.style.opacity = '0';
    } else {
      titleMain.style.opacity = '1';
    }
  }
}

window.addEventListener('scroll', handleScroll);
